import firebase from 'store/firebase';
import "firebase/functions";

import { Dispatch, AnyAction } from "redux";
import { StoreError } from "store/errors";
import { RootState } from "store/reducer";
import { RESULTS_ACTION_TYPES } from "./reducer";
import { invalidateResourceRead } from "store/util/resource-read";

export const ACTION_EVENT_RESULTS_CALCULATING = 'event_results/calulating';
export const ACTION_EVENT_RESULTS_CALCULATED = 'event_results/calcutate';
export const ACTION_EVENT_RESULTS_CALCULATE_ERROR = 'event_results/calculate_error';

export default function calculate(id: string) {
    return async (dispatch: Dispatch<AnyAction>, getState: () => RootState) => {
        dispatch({ type: ACTION_EVENT_RESULTS_CALCULATING, payload: {id, calculating: true }});
        try {
            const calculateResults = firebase.functions().httpsCallable('calculateResults');
            const response = await calculateResults(id);
            const data = response?.data || {};
            if (data?.error) {
                throw new StoreError(data.error?.message, data.error?.code);
            }
            else {
                const results = {id, ...data };
                invalidateResourceRead(getState, [RESULTS_ACTION_TYPES.startedLoading, id, undefined]);
                dispatch({ type: ACTION_EVENT_RESULTS_CALCULATED, payload: results});
            }
        }
        catch (error) {
            dispatch({ type: ACTION_EVENT_RESULTS_CALCULATE_ERROR, payload: {id, error }});
        }
        dispatch({ type: ACTION_EVENT_RESULTS_CALCULATING, payload: {id, calculating: false }});
    }
}
